export default function TextInput({ className, ...rest }) {
  return <input {...rest} className={`${className} registerInput`} />;
}
